<accredible-hint
  type="warning"
  icon="warning"
  [content]="onWalletPage() ? t('migrated_wallet_page') : t('migrated_credential_page')"
  *transloco="let t; prefix: 'migration-banner'">
  <div hintAction>
    <a
      class="issuer-link link-with-icon"
      target="_blank"
      href="https://eu.accounts.accredible.com/login">
      <span class="trailing-margin">{{ t('new_sign_in') }}</span>

      <accredible-icon [icon]="'external'" />
    </a>
  </div>
</accredible-hint>
